import React from 'react';
import { HiOutlineDocumentText, HiOutlineExternalLink, HiOutlineReply, HiBadgeCheck } from 'react-icons/hi';
import { ProviderTemplate } from '../../../../../../types/communication';
import { mrkdwnToHtml } from '../../../../../../utils/slackMrkdwn';

interface WhatsAppPreviewProps {
    provider: ProviderTemplate | undefined;
    values: Record<string, string>;
    bindings: Record<string, string>;
    to: string;
}

const fill = (body: string, bindings: Record<string, string>, values: Record<string, string>) =>
    body.replace(/\{\{(\d+)\}\}/g, (token, n: string) => {
        const variable = bindings[n];
        return variable ? values[variable] ?? `[${variable}]` : token;
    });

const WhatsAppPreview: React.FC<WhatsAppPreviewProps> = ({ provider, values, bindings, to }) => {
    const time = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    const documentVariable = bindings.documento;
    const documentName = documentVariable ? (values[documentVariable] ?? '').split('/').pop() || 'documento.pdf' : '';

    return (
        <div className="mx-auto w-[320px] rounded-[2.2rem] border-[10px] border-gray-900 bg-gray-900 shadow-xl overflow-hidden">
            <div className="bg-[#075E54] text-white px-3 py-2.5 flex items-center gap-2">
                <span className="w-8 h-8 rounded-full bg-white text-[#075E54] text-xs font-bold flex items-center justify-center">AG</span>
                <div className="flex-1 min-w-0">
                    <div className="text-sm font-semibold flex items-center gap-1">
                        Agrolend <HiBadgeCheck className="text-[#25D366]" size={14} />
                    </div>
                    <div className="text-[11px] opacity-80 truncate">para {to || 'telefone do cliente'}</div>
                </div>
            </div>
            <div className="bg-[#ECE5DD] min-h-[420px] px-3 py-4">
                {!provider ? (
                    <div className="text-center text-xs text-gray-500 bg-white/70 rounded-lg px-3 py-2 mt-24">
                        Escolha um modelo aprovado para ver a mensagem.
                    </div>
                ) : (
                    <div className="max-w-[92%]">
                        <div className="bg-white rounded-lg rounded-tl-none shadow-sm overflow-hidden">
                            {provider.header.type === 'DOCUMENT' && (
                                <div className="m-1 rounded-md bg-[#F0F2F5] px-3 py-2.5 flex items-center gap-2">
                                    <HiOutlineDocumentText className="text-red-500 shrink-0" size={26} />
                                    <span className="text-xs text-gray-700 truncate">{documentName || 'documento.pdf'}</span>
                                </div>
                            )}
                            {provider.header.type === 'TEXT' && (
                                <div className="px-2.5 pt-2 text-sm font-bold text-gray-900">{provider.header.text}</div>
                            )}
                            <div
                                className="px-2.5 pt-1.5 pb-1 text-[13.5px] leading-snug text-gray-900 break-words"
                                dangerouslySetInnerHTML={{ __html: mrkdwnToHtml(fill(provider.body, bindings, values)) }}
                            />
                            {provider.footer && <div className="px-2.5 text-[11px] text-gray-400">{provider.footer}</div>}
                            <div className="px-2.5 pb-1 text-right text-[10px] text-gray-400">{time}</div>
                        </div>
                        {provider.buttons.map((button) => (
                            <div key={button.text} className="mt-1 bg-white rounded-lg shadow-sm py-2 text-center text-[13px] text-[#00A5F4] flex items-center justify-center gap-1.5">
                                {button.type === 'URL' ? <HiOutlineExternalLink size={14} /> : <HiOutlineReply size={14} />}
                                {button.text}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default WhatsAppPreview;
